import React from 'react';

import { Grid } from '@mui/material';
import * as AdministratorsWidget from './AdministratorsWidget/AdministratorsWidget';
import * as AdministratorInvitesWidget from './AdministratorInvitesWidget/AdministratorInvitesWidget';
import { PermissionWall } from 'modules';



export const FC: React.FC = () => {
  return (
    <>
      <Grid
        container
        spacing={2}>
        <Grid
          item
          xs={6}>
          <PermissionWall.FC requiresPermissions={['user_view']}>
            <AdministratorsWidget.FC />
          </PermissionWall.FC>
        </Grid>

        <Grid
          item
          xs={6}>
          <PermissionWall.FC requiresPermissions={['user_viewInvites']}>
            <AdministratorInvitesWidget.FC />
          </PermissionWall.FC>
        </Grid>
      </Grid>
    </>
  );
};
